var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgMobilePhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xAA\xEF\xB8\x8F Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 19C8.25 18.5858 8.58579 18.25 9 18.25H15C15.4142 18.25 15.75 18.5858 15.75 19C15.75 19.4142 15.4142 19.75 15 19.75H9C8.58579 19.75 8.25 19.4142 8.25 19Z",
    fill: "#6874E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 6C4.25 3.37665 6.37665 1.25 9 1.25H15C17.6234 1.25 19.75 3.37665 19.75 6V18C19.75 20.6234 17.6234 22.75 15 22.75H9C6.37665 22.75 4.25 20.6234 4.25 18V6ZM8.25 2.83697C6.81665 3.17555 5.75 4.46321 5.75 6V18C5.75 19.7949 7.20507 21.25 9 21.25H15C16.7949 21.25 18.25 19.7949 18.25 18V6C18.25 4.46321 17.1834 3.17555 15.75 2.83697V4C15.75 4.9665 14.9665 5.75 14 5.75H10C9.0335 5.75 8.25 4.9665 8.25 4V2.83697ZM9.75 2.75V4C9.75 4.13807 9.86193 4.25 10 4.25H14C14.1381 4.25 14.25 4.13807 14.25 4V2.75H9.75Z",
    fill: "#6874E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePhone);
export default __webpack_public_path__ + "static/media/mobile-phone.e2874122006fae89933d587870804680.svg";
export { ForwardRef as ReactComponent };